<div class="xplore-page-shell height-without-bar lg:h-full">
  @if (isMobile()) {
    <section class="mobile-xplore-shell relative overflow-hidden bg-theme-mobile-shell">
      <div class="mobile-slider-wrap h-full">
        <div class="keen-slider h-full" #sliderRef>
          @for (xploreItem of xploreItems(); track xploreItem.id) {
            <div class="keen-slider__slide">
              <app-mobile-item-card [xploreItem]="xploreItem"
                [isPrimaryMedia]="$index === currentSliderIndex()"
                (userProfileClickedEvent)="onUserProfileClicked($event)">
              </app-mobile-item-card>
            </div>
          }
        </div>
      </div>

      @if (xploreItems().length === 0) {
        <div class="mobile-feed-loading absolute inset-0 z-[6] flex items-center justify-center" aria-hidden="true">
          <div class="mobile-overlay-spinner"></div>
        </div>
      }

      <div class="mobile-fade mobile-fade--top"></div>
      <div class="mobile-fade mobile-fade--bottom"></div>

      @if (showVerticalSwipeHint()) {
        <div class="mobile-swipe-hint absolute left-1/2 top-1/2 z-[11] flex flex-col items-center gap-1" aria-hidden="true">
          <svg class="mobile-swipe-hint__chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true">
            <path d="M6 15l6-6 6 6"></path>
          </svg>
          <span class="mobile-swipe-hint__label">{{ 'xplore_feed.swipe_up_hint' | translate }}</span>
        </div>
      }

      @if (currentXplore(); as current) {
        <div class="mobile-context-panel"
          #mobilePanelRef
          [class.mobile-context-panel--expanded]="mobilePanelExpanded()"
          [class.mobile-context-panel--dragging]="mobilePanelDragging()"
          (transitionend)="onMobilePanelTransitionEnd($event)"
          [style.height.px]="mobilePanelCurrentHeight()">
          <div class="mobile-context-panel__static" #mobilePanelStaticRef>
            <div class="mobile-context-panel__handle mobile-interactive m-auto flex w-full touch-pan-y flex-col items-center justify-center gap-1 border-0 bg-transparent px-0 pb-1 pt-0.5 text-white/80"
              #mobilePanelHandleRef>
              <span class="mobile-context-panel__handle-bar mb-2"></span>
              <h1 class="mobile-context-title m-0 text-center text-[22px] font-bold leading-[1.05] tracking-[-0.02em] text-white">{{ current.name }}</h1>
            </div>

            <div class="mobile-context-panel__meta-row mobile-interactive mt-2.5 flex items-center gap-2">
              <button class="mobile-icon-btn mobile-distance-btn mobile-interactive h-7 w-[76px] min-w-[76px] justify-center gap-1.5 px-2 text-xs font-bold"
                [class.mobile-distance-btn--loading]="currentDistanceChipState() === 'loading'"
                [class.mobile-distance-btn--error]="currentDistanceChipState() === 'unavailable'"
                [disabled]="currentDistanceChipState() !== 'ready'"
                (click)="onNavigateToMapClicked(current)"
                [attr.aria-label]="currentDistanceChipState() === 'ready' ? 'Distanza da te' : 'GPS non disponibile'">
                @switch (currentDistanceChipState()) {
                  @case ('loading') {
                    <span class="distance-chip-spinner" aria-hidden="true"></span>
                    <span class="mobile-distance-btn__text whitespace-nowrap text-xs font-bold tracking-[0.01em]">GPS</span>
                  }
                  @case ('unavailable') {
                    <svg class="distance-chip-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" aria-hidden="true">
                      <path d="M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7z"></path>
                      <circle cx="12" cy="9" r="2.5"></circle>
                      <path d="M3 3l18 18"></path>
                    </svg>
                  }
                  @default {
                    <span class="mobile-distance-btn__text whitespace-nowrap text-xs font-bold tracking-[0.01em]">{{ currentDistanceChipLabel() }}</span>
                  }
                }
              </button>
              @if (isBookableEventItem(current)) {
                <button class="mobile-event-book-btn mobile-interactive"
                  (click)="onEventBookingQuickAction(current)">
                  {{ 'event.book-event-button' | translate }}
                </button>
              }
              <button class="mobile-icon-btn mobile-like-btn mobile-interactive ml-auto h-7 w-[76px] min-w-[76px]" (click)="onFavoriteButtonClicked(current)"
                aria-label="Preferiti">
                <svg viewBox="0 0 24 24" [attr.fill]="isItemFavorite(current) ? 'currentColor' : 'none'"
                  [attr.stroke]="isItemFavorite(current) ? 'none' : 'currentColor'" stroke-width="2">
                  <path
                    d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54z">
                  </path>
                </svg>
              </button>
            </div>
          </div>

          @if (mobileExpandedContentVisible()) {
            <div class="mobile-expanded-content mobile-interactive mt-4 flex min-h-0 flex-1 flex-col gap-3 overflow-hidden pt-1">
              <div class="mobile-overlay-tabs grid w-full grid-cols-3 gap-1.5"
                [class.grid-cols-4]="isBookableEventItem(current)"
                role="tablist"
                aria-label="Dettagli xplore">
                <button class="mobile-overlay-tab min-h-8 w-full min-w-0 rounded-full border border-white/20 bg-white/10 px-[9px] py-1.5 text-center text-[11px] font-bold leading-[1.15] tracking-[0.02em] text-white"
                  [class.mobile-overlay-tab--active]="mobileOverlayTab() === 'description'"
                  (click)="setMobileOverlayTab('description', current)">
                  {{ 'detail_modal.segments.description' | translate }}
                </button>
                <button class="mobile-overlay-tab min-h-8 w-full min-w-0 rounded-full border border-white/20 bg-white/10 px-[9px] py-1.5 text-center text-[11px] font-bold leading-[1.15] tracking-[0.02em] text-white"
                  [class.mobile-overlay-tab--active]="mobileOverlayTab() === 'info'"
                  (click)="setMobileOverlayTab('info', current)">
                  {{ 'detail_modal.segments.info' | translate }}
                </button>
                <button class="mobile-overlay-tab min-h-8 w-full min-w-0 rounded-full border border-white/20 bg-white/10 px-[9px] py-1.5 text-center text-[11px] font-bold leading-[1.15] tracking-[0.02em] text-white"
                  [class.mobile-overlay-tab--active]="mobileOverlayTab() === 'related'"
                  (click)="setMobileOverlayTab('related', current)">
                  {{ 'detail_modal.segments.related' | translate }}
                </button>
                @if (isBookableEventItem(current)) {
                  <button class="mobile-overlay-tab min-h-8 w-full min-w-0 rounded-full border border-white/20 bg-white/10 px-[9px] py-1.5 text-center text-[11px] font-bold leading-[1.15] tracking-[0.02em] text-white"
                    [class.mobile-overlay-tab--active]="mobileOverlayTab() === 'booking'"
                    (click)="setMobileOverlayTab('booking', current)">
                    {{ 'event.book-event-button' | translate }}
                  </button>
                }
              </div>

              <div class="mobile-expanded-body min-h-0 flex-1 overflow-hidden">
                @switch (mobileOverlayTab()) {
                  @case ('description') {
                    <section class="mobile-overlay-panel mt-2 h-full overflow-y-auto overscroll-contain">
                      <div class="mobile-overlay-highlights grid grid-cols-1 gap-2.5">
                        @if (getLocationLabel(current); as locationLabel) {
                          <button class="mobile-overlay-fact mobile-overlay-fact--link flex flex-col gap-1 rounded-[14px] border border-white/20 bg-white/10 px-3.5 py-3 text-left text-inherit" (click)="onNavigateToMapClicked(current)">
                            <span class="mobile-overlay-fact__label text-[11px] font-bold uppercase tracking-[0.05em] text-white/75">{{ 'detail_modal.info_section.place' | translate }}</span>
                            <span class="mobile-overlay-fact__value break-words text-[14px] leading-[1.4] text-white/95">{{ locationLabel }}</span>
                          </button>
                        }
                        @if (current.creatorUserAccount; as creator) {
                          <button class="mobile-overlay-fact mobile-overlay-fact--link flex flex-col gap-1 rounded-[14px] border border-white/20 bg-white/10 px-3.5 py-3 text-left text-inherit" (click)="onUserProfileClicked(creator)">
                            <span class="mobile-overlay-fact__label text-[11px] font-bold uppercase tracking-[0.05em] text-white/75">Creator</span>
                            <span class="mobile-overlay-fact__value break-words text-[14px] leading-[1.4] text-white/95">{{ creator.displayedName || creator.username }}</span>
                          </button>
                        }
                      </div>

                      @if (currentPrimaryTags().length > 0) {
                        <div class="mobile-expanded-tags flex flex-nowrap gap-2 overflow-x-auto">
                          @for (tag of currentPrimaryTags(); track trackByTag($index, tag)) {
                            <button class="mobile-expanded-tag shrink-0 rounded-full px-3 py-1.5 text-[12px] font-semibold" (click)="onSearchTagClicked(tag)">
                              {{ 'tags.' + tag.code | translate }}
                            </button>
                          }
                        </div>
                      }

                      <div class="mobile-expanded-description text-[15px] leading-[1.55] text-white/95" [innerHTML]="currentDescriptionHtml()"></div>
                    </section>
                  }

                  @case ('info') {
                    <section class="mobile-overlay-panel mt-2 h-full overflow-y-auto overscroll-contain">
                      <div class="mobile-info-grid grid grid-cols-1 gap-2.5">
                        @if (getInfoPositionName(current); as positionName) {
                          <button class="mobile-info-card mobile-info-card--button flex flex-col gap-1 rounded-[14px] border border-white/20 bg-white/10 px-3.5 py-3 text-left no-underline text-inherit" (click)="onNavigateToMapClicked(current)">
                            <span class="mobile-info-card__label text-[11px] font-bold uppercase tracking-[0.05em] text-white/75">{{ 'detail_modal.info_section.place' | translate }}</span>
                            <span class="mobile-info-card__value break-words text-[14px] leading-[1.4] text-white/95">{{ positionName }}</span>
                          </button>
                        }

                        @if (current.geoPositionDTO?.mapsLink) {
                          <a class="mobile-info-card flex flex-col gap-1 rounded-[14px] border border-white/20 bg-white/10 px-3.5 py-3 text-left no-underline"
                            [href]="normalizeWebsiteUrl(current.geoPositionDTO?.mapsLink)"
                            rel="noopener noreferrer"
                            target="_blank">
                            <span class="mobile-info-card__label text-[11px] font-bold uppercase tracking-[0.05em] text-white/75">Maps</span>
                            <span class="mobile-info-card__value break-words text-[14px] leading-[1.4] text-white/95">{{ current.geoPositionDTO?.mapsLink }}</span>
                          </a>
                        }

                        @if (current.phoneNumber) {
                          <a class="mobile-info-card flex flex-col gap-1 rounded-[14px] border border-white/20 bg-white/10 px-3.5 py-3 text-left no-underline" [href]="'tel:' + current.phoneNumber">
                            <span class="mobile-info-card__label text-[11px] font-bold uppercase tracking-[0.05em] text-white/75">{{ 'detail_modal.info_section.phone' | translate }}</span>
                            <span class="mobile-info-card__value break-words text-[14px] leading-[1.4] text-white/95">{{ current.phoneNumber }}</span>
                          </a>
                        }

                        @if (current.email) {
                          <a class="mobile-info-card flex flex-col gap-1 rounded-[14px] border border-white/20 bg-white/10 px-3.5 py-3 text-left no-underline" [href]="'mailto:' + current.email">
                            <span class="mobile-info-card__label text-[11px] font-bold uppercase tracking-[0.05em] text-white/75">Email</span>
                            <span class="mobile-info-card__value break-words text-[14px] leading-[1.4] text-white/95">{{ current.email }}</span>
                          </a>
                        }

                        @if (current.website) {
                          <a class="mobile-info-card flex flex-col gap-1 rounded-[14px] border border-white/20 bg-white/10 px-3.5 py-3 text-left no-underline"
                            [href]="normalizeWebsiteUrl(current.website)"
                            rel="noopener noreferrer"
                            target="_blank">
                            <span class="mobile-info-card__label text-[11px] font-bold uppercase tracking-[0.05em] text-white/75">{{ 'detail_modal.info_section.website' | translate }}</span>
                            <span class="mobile-info-card__value break-words text-[14px] leading-[1.4] text-white/95">{{ current.website }}</span>
                          </a>
                        }

                        @if (current.instagramLink) {
                          <a class="mobile-info-card flex flex-col gap-1 rounded-[14px] border border-white/20 bg-white/10 px-3.5 py-3 text-left no-underline"
                            [href]="normalizeWebsiteUrl(current.instagramLink)"
                            rel="noopener noreferrer"
                            target="_blank">
                            <span class="mobile-info-card__label text-[11px] font-bold uppercase tracking-[0.05em] text-white/75">Instagram</span>
                            <span class="mobile-info-card__value break-words text-[14px] leading-[1.4] text-white/95">{{ current.instagramLink }}</span>
                          </a>
                        }

                        @if (current.facebookLink) {
                          <a class="mobile-info-card flex flex-col gap-1 rounded-[14px] border border-white/20 bg-white/10 px-3.5 py-3 text-left no-underline"
                            [href]="normalizeWebsiteUrl(current.facebookLink)"
                            rel="noopener noreferrer"
                            target="_blank">
                            <span class="mobile-info-card__label text-[11px] font-bold uppercase tracking-[0.05em] text-white/75">Facebook</span>
                            <span class="mobile-info-card__value break-words text-[14px] leading-[1.4] text-white/95">{{ current.facebookLink }}</span>
                          </a>
                        }

                        @if (getItemPrice(current); as price) {
                          <div class="mobile-info-card flex flex-col gap-1 rounded-[14px] border border-white/20 bg-white/10 px-3.5 py-3 text-left no-underline">
                            <span class="mobile-info-card__label text-[11px] font-bold uppercase tracking-[0.05em] text-white/75">{{ 'detail_modal.info_section.price' | translate }}</span>
                            <span class="mobile-info-card__value break-words text-[14px] leading-[1.4] text-white/95">{{ formatPrice(price) }}</span>
                          </div>
                        }

                        @if (hasDateInfo(current)) {
                          <div class="mobile-info-card flex flex-col gap-1 rounded-[14px] border border-white/20 bg-white/10 px-3.5 py-3 text-left no-underline">
                            @if (isEventItem(current)) {
                              @if (getDateStart(current); as eventDate) {
                                <span class="mobile-info-card__label text-[11px] font-bold uppercase tracking-[0.05em] text-white/75">{{ 'detail_modal.info_section.date' | translate }}</span>
                                <span class="mobile-info-card__value break-words text-[14px] leading-[1.4] text-white/95">{{ eventDate | date: 'dd MMM yyyy' }}</span>
                              }
                              @if (getBookableUntil(current); as bookableUntil) {
                                <span class="mobile-info-card__label text-[11px] font-bold uppercase tracking-[0.05em] text-white/75">{{ 'detail_modal.info_section.bookable_until' | translate }}</span>
                                <span class="mobile-info-card__value break-words text-[14px] leading-[1.4] text-white/95">{{ bookableUntil | date: 'dd MMM yyyy' }}</span>
                              }
                            } @else {
                              @if (getDateStart(current); as startDate) {
                                <span class="mobile-info-card__label text-[11px] font-bold uppercase tracking-[0.05em] text-white/75">{{ 'detail_modal.info_section.start' | translate }}</span>
                                <span class="mobile-info-card__value break-words text-[14px] leading-[1.4] text-white/95">{{ startDate | date: 'dd MMM yyyy' }}</span>
                              }
                              @if (getDateEnd(current); as endDate) {
                                <span class="mobile-info-card__label text-[11px] font-bold uppercase tracking-[0.05em] text-white/75">{{ 'detail_modal.info_section.end' | translate }}</span>
                                <span class="mobile-info-card__value break-words text-[14px] leading-[1.4] text-white/95">{{ endDate | date: 'dd MMM yyyy' }}</span>
                              }
                            }
                          </div>
                        }

                        @if (hasHourInfo(current)) {
                          <div class="mobile-info-card flex flex-col gap-1 rounded-[14px] border border-white/20 bg-white/10 px-3.5 py-3 text-left no-underline">
                            @if (getOpenHour(current); as openHour) {
                              <span class="mobile-info-card__label text-[11px] font-bold uppercase tracking-[0.05em] text-white/75">{{ 'detail_modal.info_section.hour.start' | translate }}</span>
                              <span class="mobile-info-card__value break-words text-[14px] leading-[1.4] text-white/95">{{ openHour | date: 'HH:mm' }}</span>
                            }
                            @if (getCloseHour(current); as closeHour) {
                              <span class="mobile-info-card__label text-[11px] font-bold uppercase tracking-[0.05em] text-white/75">{{ 'detail_modal.info_section.hour.end' | translate }}</span>
                              <span class="mobile-info-card__value break-words text-[14px] leading-[1.4] text-white/95">{{ closeHour | date: 'HH:mm' }}</span>
                            }
                          </div>
                        }
                      </div>
                    </section>
                  }

                  @case ('related') {
                    <section class="mobile-overlay-panel mt-2 h-full overflow-y-auto overscroll-contain">
                      @if (mobileRelatedItemsLoading()) {
                        <div class="mobile-related-state flex min-h-[150px] flex-col items-center justify-center gap-2.5 rounded-[14px] border border-white/20 bg-white/10 p-4 text-center text-[14px]">
                          <div class="mobile-overlay-spinner" aria-hidden="true"></div>
                        </div>
                      } @else if (mobileRelatedItemsError()) {
                        <div class="mobile-related-state flex min-h-[150px] flex-col items-center justify-center gap-2.5 rounded-[14px] border border-white/20 bg-white/10 p-4 text-center text-[14px]">
                          <p>{{ 'alter.msg' | translate }}</p>
                          <button class="mobile-related-retry rounded-full border px-3 py-1.5 text-xs font-bold" (click)="setMobileOverlayTab('related', current)">Riprova</button>
                        </div>
                      } @else if (mobileRelatedItems().length === 0) {
                        <div class="mobile-related-state flex min-h-[150px] flex-col items-center justify-center gap-2.5 rounded-[14px] border border-white/20 bg-white/10 p-4 text-center text-[14px]">
                          <p>{{ 'related_not_available_title' | translate }}</p>
                        </div>
                      } @else {
                        <div class="mobile-related-grid grid grid-cols-2 gap-2.5">
                          @for (relatedItem of mobileRelatedItems(); track trackBySimpleXploreItem($index, relatedItem)) {
                            <button class="mobile-related-card flex flex-col overflow-hidden rounded-[14px] border-0 bg-white/10 p-0 text-left shadow-[0_8px_24px_rgba(0,0,0,0.2)]" (click)="onRelatedItemClicked(relatedItem)">
                              <img class="aspect-[9/11] w-full object-cover" [src]="getRelatedItemImage(relatedItem)" [alt]="relatedItem.name">
                              <span class="mobile-related-card__type px-2.5 pt-2 text-[11px] font-bold uppercase tracking-[0.04em] text-theme-primary-muted">{{ relatedItem.itemType }}</span>
                              <span class="mobile-related-card__title px-2.5 pb-[11px] pt-1 text-[14px] font-bold leading-[1.3] text-white/95">{{ relatedItem.name }}</span>
                            </button>
                          }
                        </div>
                      }
                    </section>
                  }

                  @case ('booking') {
                    <section class="mobile-overlay-panel mt-2 h-full overflow-y-auto overscroll-contain">
                      @if (isEventItem(current)) {
                        <div class="mobile-booking-panel rounded-[14px] border border-white/20 bg-white/10">
                          <book-section [xploreItem]="current"></book-section>
                        </div>
                      }
                    </section>
                  }
                }
              </div>

              <div class="mobile-expanded-actions mt-2 flex items-center gap-2">
                @if (current.immersiveUrl) {
                  <button class="mobile-icon-btn" (click)="onImmersiveButtonClicked(current)" aria-label="Apri immersiva">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                      <path d="M2 7l10-5 10 5-10 5-10-5z"></path>
                      <path d="M2 17l10 5 10-5"></path>
                      <path d="M2 12l10 5 10-5"></path>
                    </svg>
                  </button>
                }
                @if (canShare) {
                  <button class="mobile-icon-btn" (click)="onShareButtonClicked(current)" aria-label="Condividi">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                      <path d="M7 12l10-7M7 12l10 7M7 12h0"></path>
                      <circle cx="18" cy="5" r="3"></circle>
                      <circle cx="18" cy="19" r="3"></circle>
                      <circle cx="6" cy="12" r="3"></circle>
                    </svg>
                  </button>
                }
              </div>
            </div>
          }
        </div>
      }
    </section>
  }

  @if (!isMobile()) {
    <section class="desktop-single-shell px-[18px] pb-16 lg:mt-[112px]">
      <div class="mx-auto flex w-full max-w-[1420px] flex-col gap-8">
        @if (currentXplore(); as current) {
          <article class="desktop-focus-card">
            <div class="desktop-focus-media">
              <div class="desktop-focus-media-frame">
                <img [ngSrc]="getDesktopMediaUrl(current, desktopActiveMediaIndex())" [alt]="current.name" width="540" height="960">

                @if (getDesktopMediaCount(current) > 1) {
                  <button class="desktop-focus-media-nav desktop-focus-media-nav--prev" type="button" (click)="showPreviousDesktopMedia(current)" aria-label="Foto precedente">
                    ‹
                  </button>
                  <button class="desktop-focus-media-nav desktop-focus-media-nav--next" type="button" (click)="showNextDesktopMedia(current)" aria-label="Foto successiva">
                    ›
                  </button>
                  <div class="desktop-focus-media-counter">
                    {{ desktopActiveMediaIndex() + 1 }} / {{ getDesktopMediaCount(current) }}
                  </div>
                }
              </div>

              @if (getDesktopMediaCount(current) > 1) {
                <div class="desktop-focus-thumbs">
                  @for (media of current.multiMedia; track $index) {
                    <button class="desktop-focus-thumb" type="button"
                      [class.desktop-focus-thumb--active]="desktopActiveMediaIndex() === $index"
                      (click)="setDesktopMediaIndex(current, $index)">
                      <img [ngSrc]="getDesktopMediaUrl(current, $index)" [alt]="current.name + ' foto ' + ($index + 1)" width="72" height="128">
                    </button>
                  }
                </div>
              }
            </div>

            <div class="desktop-focus-content">
              <div class="desktop-feed-topline">
                <span class="desktop-type-chip">{{ current.itemType }}</span>
                <div class="desktop-focus-topline-actions">
                  <button class="desktop-distance-chip"
                    [class.desktop-distance-chip--loading]="currentDistanceChipState() === 'loading'"
                    [class.desktop-distance-chip--error]="currentDistanceChipState() === 'unavailable'"
                    [disabled]="currentDistanceChipState() !== 'ready'"
                    (click)="onNavigateToMapClicked(current)"
                    [attr.aria-label]="currentDistanceChipState() === 'ready' ? 'Distanza da te' : 'GPS non disponibile'">
                    @switch (currentDistanceChipState()) {
                      @case ('loading') {
                        <span class="distance-chip-spinner" aria-hidden="true"></span>
                      }
                      @case ('unavailable') {
                        <svg class="distance-chip-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" aria-hidden="true">
                          <path d="M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7z"></path>
                          <circle cx="12" cy="9" r="2.5"></circle>
                          <path d="M3 3l18 18"></path>
                        </svg>
                      }
                      @default {
                        {{ currentDistanceChipLabel() }}
                      }
                    }
                  </button>

                  <button class="desktop-icon-btn" (click)="onFavoriteButtonClicked(current)" aria-label="Preferiti">
                    <svg viewBox="0 0 24 24" [attr.fill]="isItemFavorite(current) ? 'currentColor' : 'none'"
                      [attr.stroke]="isItemFavorite(current) ? 'none' : 'currentColor'" stroke-width="2">
                      <path
                        d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54z">
                      </path>
                    </svg>
                  </button>
                </div>
              </div>

              <h1 class="desktop-name">{{ current.name }}</h1>

              @if (getLocationLabel(current); as locationLabel) {
                <p class="desktop-location">{{ locationLabel }}</p>
              }

              @if (canShare || current.immersiveUrl) {
                <div class="desktop-actions">
                  @if (canShare) {
                    <button class="desktop-icon-btn" (click)="onShareButtonClicked(current)" aria-label="Condividi">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                        <path d="M7 12l10-7M7 12l10 7M7 12h0"></path>
                        <circle cx="18" cy="5" r="3"></circle>
                        <circle cx="18" cy="19" r="3"></circle>
                        <circle cx="6" cy="12" r="3"></circle>
                      </svg>
                    </button>
                  }
                  @if (current.immersiveUrl) {
                    <button class="desktop-icon-btn" (click)="onImmersiveButtonClicked(current)" aria-label="Apri immersiva">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                        <path d="M2 7l10-5 10 5-10 5-10-5z"></path>
                        <path d="M2 17l10 5 10-5"></path>
                        <path d="M2 12l10 5 10-5"></path>
                      </svg>
                    </button>
                  }
                </div>
              }

              @if (getSummary(current); as summary) {
                <p class="desktop-summary desktop-summary--expanded">{{ summary }}</p>
              }

              <div class="desktop-info-grid desktop-info-grid--single-focus">
                @if (current.creatorUserAccount; as creator) {
                  <div class="desktop-info-item">
                    <span class="desktop-info-label">Creator</span>
                    <button class="desktop-info-value desktop-link" (click)="onUserProfileClicked(creator)">
                      {{ creator.displayedName || creator.username }}
                    </button>
                  </div>
                }

                @if (getInfoPositionName(current); as positionName) {
                  <div class="desktop-info-item">
                    <span class="desktop-info-label">{{ 'detail_modal.info_section.place' | translate }}</span>
                    <span class="desktop-info-value">{{ positionName }}</span>
                  </div>
                }

                @if (current.phoneNumber) {
                  <div class="desktop-info-item">
                    <span class="desktop-info-label">{{ 'detail_modal.info_section.phone' | translate }}</span>
                    <a class="desktop-info-value desktop-link" [href]="'tel:' + current.phoneNumber">
                      {{ current.phoneNumber }}
                    </a>
                  </div>
                }

                @if (current.website) {
                  <div class="desktop-info-item">
                    <span class="desktop-info-label">{{ 'detail_modal.info_section.website' | translate }}</span>
                    <a class="desktop-info-value desktop-link"
                      [href]="normalizeWebsiteUrl(current.website)"
                      rel="noopener noreferrer"
                      target="_blank">
                      {{ current.website }}
                    </a>
                  </div>
                }

                @if (current.email) {
                  <div class="desktop-info-item">
                    <span class="desktop-info-label">Email</span>
                    <a class="desktop-info-value desktop-link" [href]="'mailto:' + current.email">
                      {{ current.email }}
                    </a>
                  </div>
                }

                @if (getItemPrice(current); as price) {
                  <div class="desktop-info-item">
                    <span class="desktop-info-label">{{ 'detail_modal.info_section.price' | translate }}</span>
                    <span class="desktop-info-value">{{ formatPrice(price) }}</span>
                  </div>
                }

                @if (hasDateInfo(current)) {
                  <div class="desktop-info-item">
                    <span class="desktop-info-label">{{ 'detail_modal.info_section.date' | translate }}</span>
                    <span class="desktop-info-value">
                      @if (getDateStart(current); as startDate) {
                        {{ startDate | date: 'dd MMM yyyy' }}
                      }
                      @if (getDateEnd(current); as endDate) {
                        @if (getDateStart(current)) {
                          - 
                        }
                        {{ endDate | date: 'dd MMM yyyy' }}
                      }
                    </span>
                  </div>
                }

                @if (hasHourInfo(current)) {
                  <div class="desktop-info-item">
                    <span class="desktop-info-label">{{ 'detail_modal.info_section.hour.header' | translate }}</span>
                    <span class="desktop-info-value">
                      @if (getOpenHour(current); as openHour) {
                        {{ openHour | date: 'HH:mm' }}
                      }
                      @if (getCloseHour(current); as closeHour) {
                        -
                        {{ closeHour | date: 'HH:mm' }}
                      }
                    </span>
                  </div>
                }
              </div>

              @if (currentCategoryLabels(); as categoryLabels) {
                @if (categoryLabels.length > 0) {
                  <div class="desktop-tags">
                    @for (label of categoryLabels; track trackByLabel($index, label)) {
                      <span class="desktop-inline-pill">{{ label }}</span>
                    }
                  </div>
                }
              }

              @if (currentPrimaryTags().length > 0) {
                <div class="desktop-tags">
                  @for (tag of currentPrimaryTags(); track trackByTag($index, tag)) {
                    <button class="desktop-tag" (click)="onSearchTagClicked(tag)">
                      {{ 'tags.' + tag.code | translate }}
                    </button>
                  }
                </div>
              }
            </div>
          </article>
        }

        <section
          (scrolled)="onScroll()"
          [infiniteScrollDistance]="1.2"
          [infiniteScrollThrottle]="80"
          [scrollWindow]="true"
          infiniteScroll
          class="desktop-recommended-section">
          <div class="desktop-recommended-header">
            <h2 class="desktop-recommended-title">Continua ad esplorare...</h2>
          </div>

          @if (desktopRecommendedItems().length > 0 || loadingMoreXploreItems()) {
            <div class="desktop-recommended-grid">
              @for (item of desktopRecommendedItems(); track item.id) {
                <button class="desktop-recommended-card" type="button" (click)="onDesktopRecommendedItemClicked(item)">
                  <img [ngSrc]="getCoverImage(item)" [alt]="item.name" width="360" height="640">
                  <div class="desktop-recommended-card__shadow"></div>
                  <div class="desktop-recommended-card__content">
                    <span class="desktop-recommended-card__type">{{ item.itemType }}</span>
                    <h3 class="desktop-recommended-card__title">{{ item.name }}</h3>
                    @if (getLocationLabel(item); as itemLocation) {
                      <p class="desktop-recommended-card__location">{{ itemLocation }}</p>
                    }
                  </div>
                </button>
              }

              @if (loadingMoreXploreItems()) {
              @for (skeleton of desktopRecommendedSkeletons; track $index) {
                <div class="desktop-recommended-card desktop-recommended-card--skeleton" aria-hidden="true">
                  <div class="desktop-recommended-card__skeleton-gradient"></div>
                </div>
              }
              }
            </div>
          } @else {
            <div class="desktop-recommended-empty">
              {{ 'related_not_available_title' | translate }}
            </div>
          }
        </section>
      </div>
    </section>
  }
</div>
